/**
 * 「サーバーから進捗を読み戻した」合図(docs/04_data_model.md §5.1)。
 *
 * 読み戻しは `services/firebase/hydrateService.ts` が
 * **表示キャッシュ(localStorage)を書き換える**ところまでやる。
 * 画面はそのあと「もう一度キャッシュを読む」だけでよいので、
 * ここが持つのは引数も戻り値も無い最小の合図だけ。
 *
 * ストア(`gameStore` など)はここを購読する。**Firebase に触れないモジュール**に
 * 置いてあるのが大事で、ストアが `services/firebase/*` を静的 import すると
 * ローカルモードのユーザーにも SDK チャンクが載ってしまう(CLAUDE.md ルール6)。
 */

type HydrationListener = () => void;

const listeners = new Set<HydrationListener>();

/** 読み戻しが終わったら呼ばれる。戻り値で購読を解除する。 */
export function onHydrated(listener: HydrationListener): () => void {
  listeners.add(listener);
  return () => void listeners.delete(listener);
}

/** 読み戻しが終わったことを知らせる(呼ぶのは hydrateService だけ)。 */
export function notifyHydrated(): void {
  for (const listener of [...listeners]) {
    try {
      listener();
    } catch (error) {
      // 1つの画面の都合で他の画面の更新を止めない。
      console.warn('[paltyping] 読み戻しの通知で例外が出ました', error);
    }
  }
}

/** テスト用。購読を全部外す。 */
export function resetHydrationListeners(): void {
  listeners.clear();
}
